import React, { Component } from 'react';
import footer from '../../assets/JJ_Logo.png';
import {Link} from 'react-router-dom';
class Footer extends Component {
    render() {
        return (
            <div className="footercontent">
                <img className="footerimg" src={footer} alt="Smiley face" />
                <span className="footerP">All contents © Copyright Johnson & Johnson Services, All rights Reserved</span>
                <span className="footerP" style={{textAlign:"right"}}>
                    <Link to="/PrivacyPolicy">
                        Privacy Policy
                    </Link> 
                    <Link to="/LegalNotice">
                        Legal Notice
                    </Link>
                    <Link to="/FAQs">
                        Frequently Asked Questions (FAQs)
                    </Link>  
                </span>
            </div>
        );
    }
}
export default Footer;